import { render, staticRenderFns } from "./NestedRoute.vue?vue&type=template&id=997d829c&scoped=true&"
import script from "./NestedRoute.vue?vue&type=script&lang=js&"
export * from "./NestedRoute.vue?vue&type=script&lang=js&"
import style0 from "./NestedRoute.vue?vue&type=style&index=0&id=997d829c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997d829c",
  null
  
)

export default component.exports